import {
  ApiServices,
  BetsService,
  ChatService,
  UsersService,
  RoundsService,
  ApiServiceTypes,
  StatisticsService,
  TranslationService,
  environmentBuilder,
} from '@pascal/pascal-core';

import { gameName } from '../enums';

export const registerApis = () => {
  const { httpUrl: url, httpTranslationUrl, chatHttpUrl } = environmentBuilder(gameName);

  ApiServices.register(ApiServiceTypes.BetsService, new BetsService({ url }));
  ApiServices.register(ApiServiceTypes.UsersService, new UsersService({ url }));
  ApiServices.register(ApiServiceTypes.RoundsService, new RoundsService({ url }));
  ApiServices.register(ApiServiceTypes.StatisticsService, new StatisticsService({ url }));
  ApiServices.register(ApiServiceTypes.ChatService, new ChatService({ chatHttpUrl }));
  ApiServices.register(
    ApiServiceTypes.TranslationService,
    new TranslationService({ url: httpTranslationUrl })
  );
};
